export default __webpack_public_path__ + "static/media/330_dummy2016-delikatessen01.3d3d5563.png";